import type { ComponentType } from 'react';
import { NavLink } from 'react-router-dom';
import { SECTIONS, type SectionKey } from './sections';

export interface SectionTab {
  readonly label: string;
  readonly to: string;
  readonly end?: boolean;
  readonly icon?: ComponentType<{ className?: string; strokeWidth?: number | string }>;
}

export function SectionTabs({
  section,
  tabs,
}: {
  section: SectionKey;
  tabs: readonly SectionTab[];
}) {
  const sec = SECTIONS[section];

  return (
    <div
      className="sticky z-20 md:top-0"
      style={{ top: 'calc(var(--mobile-topbar-height, 64px) + env(safe-area-inset-top))' }}
    >
      <div className="mx-auto max-w-7xl px-4 pb-1.5 pt-2 sm:px-6 md:pb-2 md:pt-3">
        <div
          className="flex items-center gap-2.5 overflow-x-auto rounded-[24px] border border-border p-2 shadow-sm backdrop-blur-xl"
          style={{
            background: `linear-gradient(180deg, rgba(255,255,255,0.38) 0%, ${sec.dock} 100%)`,
            borderColor: sec.edge,
          }}
        >
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className="inline-flex min-h-[48px] items-center justify-center gap-1.5 whitespace-nowrap rounded-[18px] px-4 py-2.5 text-small font-semibold transition-all duration-150"
                style={({ isActive }) =>
                  isActive
                    ? {
                        background: `linear-gradient(135deg, ${sec.color} 0%, color-mix(in srgb, ${sec.color} 82%, #0f172a 18%) 100%)`,
                        color: '#ffffff',
                        boxShadow: '0 14px 24px -18px rgba(15,23,42,0.45)',
                      }
                    : {
                        color: 'var(--ink-muted)',
                        background: sec.surface,
                      }
                }
              >
                {Icon && <Icon className="h-4 w-4" strokeWidth={1.9} />}
                <span>{tab.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </div>
  );
}
